module.exports = __webpack_public_path__ + "img/instances-background-dark.08523344.png";